/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import ActionModel from 'cio/models/action';
import { PathData, PathType } from 'cio/utils/visual-workflow-builder/branch-paths';

interface PathLabelContentLabelArgs {
  item: {
    action: ActionModel;
  };
  edge: PathData;
  pathIndex: number;
  edgesCount: number;
  isHighlighted: boolean;
}

export default class PathLabelContentLabel extends Component<PathLabelContentLabelArgs> {
  PathType = PathType;
}
